import { Component, OnInit, ViewChild, Input, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { ScheduleDate, CompanyRef, Uploadable, Contract } from '@akiba/models_bimbo';
import { MatTable, MatDialog, MatDatepickerInputEvent } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { Subscription } from 'rxjs';
import { AppState } from 'projects/bimbo/src/app/models/appState';
import { ShareSaving } from 'projects/bimbo/src/app/models/shareSaving';
import { LogicService } from 'projects/bimbo/src/app/services/logic.service';
import { Moment } from 'moment';
import * as moment from 'moment';
import { InfoDialogComponent } from 'projects/bimbo/src/app/dialogs/info-dialog/info-dialog.component';
import { NgModel } from '@angular/forms';

@Component({
  selector: 'app-ss-parameters',
  templateUrl: './ss-parameters.component.html',
  styleUrls: ['./ss-parameters.component.scss']
})
export class SsParametersComponent implements OnInit, OnDestroy, OnChanges {

  generalSubscription: Subscription = null;

  /////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////

  @ViewChild('registrationDatesTable', { static: false }) registrationDatesTable: MatTable<ScheduleDate>;
  @ViewChild('minAmount', { static: false }) minAmount: NgModel;
  @ViewChild('maxDays', { static: false }) maxDays: NgModel;

  displayedRegistrationDatesColumns: string[] = ['Inicio', 'Fin', 'active', 'delete'];
  displayedCompanyColumns: string[] = ['companyID', 'companyName', 'taxationIdentificationNumber', 'select'];
  displayedContractColumns: string[] = ['contractID', 'description', 'select'];

  selectionCompanies: SelectionModel<CompanyRef>;
  selectionContracts: SelectionModel<Contract>;

  appModChangesSubscription: Subscription = null;
  selectionCompaniesSubscription: Subscription = null;
  selectionContractSubscription: Subscription = null;
  resetModPeriodSubscription: Subscription = null;

  newRegistrationDate = new ScheduleDate();
  @Input() contentLocation: AppState;
  @Input() modParameter: ShareSaving;
  constructor(public logicService: LogicService, public dialog: MatDialog) {

    this.selectionCompanies = new SelectionModel<CompanyRef>(true, [], true);
    this.selectionContracts = new SelectionModel<Contract>(true, [], true);

    this.generalSubscription = this.logicService.dataManager.generalDataLoader.changes.subscribe(p => {

      if (p && p.response) {

        this.doSubscriptions();

      }

    });

    this.logicService.dataManager.generalDataLoader.load();


  }
  ngOnChanges(changes: SimpleChanges): void {
    this.doSubscriptions();
  
  }

  ngOnInit() {

  }

  switchTo(anIndex: number) {
    this.contentLocation.savingParametersIndex = anIndex;
  }

  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////

  detectFiles(event: any, type: string) {

    if (!event.target.files.length) {
      return;
    }

    const file: File = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      const aDate = new Date().getTime().toString();
      this.modParameter.savingParameter.fileUploaded = new Uploadable();
      this.modParameter.savingParameter.fileUploaded.bucket = 'files/' + this.modParameter.parametersID + '_' + aDate + '_' + file.name;
      this.modParameter.savingParameter.fileUploaded.name = aDate + '_' + file.name;
      this.modParameter.savingParameter.fileUploaded.file = file;
    };

    reader.readAsDataURL(file);
    
  }

  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////


  setRegistrationDate(type: string, event: MatDatepickerInputEvent<Moment>) {
    if (type === 'starts') {
      this.newRegistrationDate.startDate = event.value.toDate();
    } else if (type === 'ends') {
      this.newRegistrationDate.endDate = event.value.toDate();
    }
  }

  addDateFirstDiscount(event: MatDatepickerInputEvent<Moment>) {

    const weeknumber = moment(event.value.toDate()).week();
    this.modParameter.savingParameter.firstDiscount.dateFirstDiscount = event.value.toDate();
    this.modParameter.savingParameter.firstDiscount.weekNumber = weeknumber;

    console.log('weeknumber', weeknumber);
    

  }

  addRegistrationDate() {

    if (!this.newRegistrationDate.startDate) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Las fecha de inicio es requerida.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.isNewDateValid(this.newRegistrationDate)) {

      this.newRegistrationDate.active = true;
      this.newRegistrationDate.scheduleDateID = this.newRegistrationDate.startDate.getTime().toString();
      this.modParameter.savingParameter.registrationDates.push(this.newRegistrationDate);

      this.newRegistrationDate = new ScheduleDate();
      this.newRegistrationDate.startDate = null;
      this.newRegistrationDate.endDate = null;
      this.newRegistrationDate.scheduleDateID  = null;

      if (this.registrationDatesTable) {
        this.registrationDatesTable.renderRows();
      }

    } else {

      if (!this.newRegistrationDate.endDate) {

        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'Las fecha de fin de inscripción es requerida.',
            close: 'Aceptar'
          }
        });

        return;

      }

    }

  }

  deleteRegistrationDate(index: number) {
    this.modParameter.savingParameter.registrationDates.splice(index, 1);
    this.registrationDatesTable.renderRows();
  }

  
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  reset() {

    this.newRegistrationDate = new ScheduleDate();
    this.newRegistrationDate.startDate = null;
    this.newRegistrationDate.endDate = null;

    this.selectionCompanies.clear();
    this.selectionContracts.clear();

  }

  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////

  isNewDateValid(aPeriodDate: ScheduleDate): boolean {

    let valid = false;
    if (aPeriodDate.startDate) {
        if (aPeriodDate.endDate) {
          valid = true;
        }
    }

    return valid;

  }

  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////


  doSubscriptions() {

    if (!this.modParameter || !this.modParameter.savingParameter) {
      return;
    }

    if(this.modParameter.savingParameter.registrationDates){

      this.modParameter.savingParameter.registrationDates = this.modParameter.savingParameter.registrationDates.map( e => new ScheduleDate(e))

    }

    this.selectionCompanies = new SelectionModel<CompanyRef>(true, [], true);

    if (this.selectionCompaniesSubscription && !this.selectionCompaniesSubscription.closed) {
      this.selectionCompaniesSubscription.unsubscribe();
      this.selectionCompaniesSubscription = null;
    }

    this.logicService.dataManager.generalDataLoader.companies.forEach(cr => {
      const index = this.modParameter.savingParameter.includedCompanies.map(ic => ic.companyID).indexOf(cr.companyID);
      if (index >= 0) {
        this.selectionCompanies.select(cr);
      }
    });

    this.selectionCompaniesSubscription = this.selectionCompanies.changed.subscribe(x => {

      if (x.added.length) {

        x.added.forEach(element => {
          const index = this.modParameter.savingParameter.includedCompanies.findIndex(ic => ic.companyID === element.companyID);
          if (index < 0) {
            this.modParameter.savingParameter.includedCompanies.push(element);
          }
        });

      } else if (x.removed.length) {

        x.removed.forEach(element => {
          const index = this.modParameter.savingParameter.includedCompanies.findIndex(ic => ic.companyID === element.companyID);
          this.modParameter.savingParameter.includedCompanies.splice(index, 1);
        });

      }

    });

    this.selectionContracts = new SelectionModel<Contract>(true, [], true);

    if (this.selectionContractSubscription && !this.selectionContractSubscription.closed) {
      this.selectionContractSubscription.unsubscribe();
      this.selectionContractSubscription = null;
    }

    this.logicService.dataManager.generalDataLoader.contracts.forEach(cr => {
      const index = this.modParameter.savingParameter.contractTypes.indexOf(cr.contractID);
      if (index >= 0) {
        this.selectionContracts.select(cr);
      }
    });

    this.selectionContractSubscription = this.selectionContracts.changed.subscribe(x => {

      if (x.added.length) {

        x.added.forEach(element => {
          const index = this.modParameter.savingParameter.contractTypes.findIndex(ic => ic === element.contractID);
          if (index < 0) {
            this.modParameter.savingParameter.contractTypes.push(element.contractID);
          }
        });

      } else if (x.removed.length) {

        x.removed.forEach(element => {
          const index = this.modParameter.savingParameter.contractTypes.findIndex(ic => ic === element.contractID);
          this.modParameter.savingParameter.contractTypes.splice(index, 1);
        });

      }

    });

    if (this.registrationDatesTable) {
      this.registrationDatesTable.renderRows();
    }

  }

  cancelSubscriptions() {

    if (this.generalSubscription && !this.generalSubscription.closed) {
      this.generalSubscription.unsubscribe();
      this.generalSubscription = null;
    }

    if (this.appModChangesSubscription && !this.appModChangesSubscription.closed) {
      this.appModChangesSubscription.unsubscribe();
      this.appModChangesSubscription = null;
    }

    if (this.selectionCompaniesSubscription && !this.selectionCompaniesSubscription.closed) {
      this.selectionCompaniesSubscription.unsubscribe();
      this.selectionCompaniesSubscription = null;
    }

    if (this.resetModPeriodSubscription && !this.resetModPeriodSubscription.closed) {
      this.resetModPeriodSubscription.unsubscribe();
      this.resetModPeriodSubscription = null;
    }

  }

  ngOnDestroy(): void {

    this.cancelSubscriptions();

  }

}
